import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";

import { request } from "../request/request";

const initialState = {
    categories: [],
    loadingStatus: "idle",
    error: null
}

export const fetchViolationsFields = createAsyncThunk(
    'violationsFields/fetchViolationsFields',
    async ({token}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = await request(
                `${APP_URL}/surveys/violations/create`,
                'GET',
                null,
                customHeaders
            )

            return response
        } catch (error) {
            rejectWithValue(error.status);
        }
    }
)

const violationsFieldsSlice = createSlice({
    name: "violationsFields",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchViolationsFields.pending, (state) => {
                state.categories = [];
                state.loadingStatus = "loading";
                state.error = null;
            })
            .addCase(fetchViolationsFields.fulfilled, (state, action) => {
                state.categories = action.payload?.categories || [];
                state.loadingStatus = "idle";
                state.error = null;
            })
            .addCase(fetchViolationsFields.rejected, (state, action) => {
                state.categories = [];
                state.loadingStatus = "error";
                state.error = action.payload;
            })
    }
})

export default violationsFieldsSlice.reducer;